<template>
  <div class="suggested">
    <div class="first">
      <suggested-cell
        :item="suggestions.first"
        v-if="suggestions.first"
        @on-pintop="pintop"
      ></suggested-cell>
    </div>
    <div class="others">
      <suggested-cell
        v-for="(suggestion, index) in suggestions.rest.slice(0, 6)"
        :item="suggestion"
        :key="index"
        @on-pintop="pintop"
      >
      </suggested-cell>
    </div>
    <div class="rest">
      <div>
        <suggested-cell
          v-for="(suggestion, index) in suggestions.rest.slice(6)"
          :item="suggestion"
          :key="index"
          @on-pintop="pintop"
        >
        </suggested-cell>
      </div>
    </div>
  </div>
</template>

<style scoped>
.suggested {
  margin: 20px;
  border: 1px solid #EFF2F7;
  height: 340px;
  display: flex;
  flex-wrap: wrap;
}

.first {
  flex: 1 1 40%;
  display: flex;
  height: 70%;
}

.others {
  flex: 1 1 60%;
  display: flex;
  flex-wrap: wrap;
  height: 70%;
}

.others > div {
  width: 33.3333333%;
  display: flex;
  height: 50%;
}

.rest {
  height: 30%;
  display: flex;
  overflow-x: scroll;
  position: relative;
}

.rest > div {
  display: flex;
  flex-wrap: nowrap;
  margin-bottom: 7px;
}

</style>

<script>
import { mapActions, mapGetters } from 'vuex'

import SuggestedCell from './SuggestedCell'

export default {
  components: {
    SuggestedCell
  },
  computed: {
    ...mapGetters('suggestions', {
      latestSuggestions: 'latestSuggestions'
    }),
    suggestions () {
      const [first, ...rest] = this.latestSuggestions
      return { first, rest }
    }
  },
  methods: {
    ...mapActions('suggestions', ['pintop'])
  }
}
</script>






// WEBPACK FOOTER //
// src/components/suggestions/Suggested.vue